export const MY_SCORES = {
  TYPES: {
    bar: 'bar',
    desktopDashboard: 'desktopDashboard',
    mobileDashboard: 'mobileDashboard'
  },

  ACTION_TYPES: {
    pageChange: 'pageChange',
    scrollButtonDisplay: 'scrollButtonDisplay',
    scrollButtonClick: 'scrollButtonClick',
    onLiveClick: 'onLiveClick',
    onTabClick: 'onTabClick',
    onPageChange: 'onPageChange',
    gameClick: 'gameClick'
  },

  TABS: {
    myScores: {
      index : 0,
      termKey: 'WEB_MY_SCORES_TITLE',
      analyticsName: 'My-scores'
    },

    mySelections: {
      index : 1,
      termKey: 'MY_SELECTIONS_TAB_NAME',
      analyticsName: 'Following'
    }
  },

  CURRENT_DATES_RANGE: 3,
  WEEK_DAYS: 7
};
